const fetchConversation = (state, action) => {
  const { status } = action;
  switch (status) {
    case 'started':
      return {
        ...state,
        fetchingConversations: true,
      };
    case 'success':
      return {
        ...state,
        fetchingConversations: false,
      };
    case 'error':
      return {
        ...state,
        fetchingConversations: false,
      };
    default:
      return state;
  }
};

export default fetchConversation;
